import { render, staticRenderFns } from "./Blankstate.vue?vue&type=template&id=70b98dbb&scoped=true"
import script from "./Blankstate.vue?vue&type=script&lang=js"
export * from "./Blankstate.vue?vue&type=script&lang=js"
import style0 from "./Blankstate.vue?vue&type=style&index=0&id=70b98dbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b98dbb",
  null
  
)

export default component.exports